import { useState } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu"; // Add this import
import MenuItem from "@mui/material/MenuItem"; // Add this import
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import data from "layouts/dashboard/components/Projects/data";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import TablePagination from "@mui/material/TablePagination";

function Projects() {
  const { columns, rows } = data();
  const [menu, setMenu] = useState(null);

  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <MenuItem onClick={closeMenu}>Action</MenuItem>
      <MenuItem onClick={closeMenu}>Another action</MenuItem>
      <MenuItem onClick={closeMenu}>Something else</MenuItem>
    </Menu>
  );

  return (
    <Card style={{ width: "1250px" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Product list Top 20
          </MDTypography>
        </MDBox>

        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
          <div>
            <span
              type="button"
              className="bg-blue-400 h-[5vh] rounded-md text-sm w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
            >
              Today
            </span>
          </div>

          <div>
            <span
              type="button"
              className="bg-blue-400 h-[5vh] rounded-md text-sm w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
            >
              7 Days
            </span>
          </div>

          <div style={{ marginRight: "-90%" }}>
            <span
              type="button"
              className="bg-blue-400 h-[5vh] rounded-md text-sm w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
            >
              30 Days
            </span>
          </div>
        </div>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["SingleInputDateRangeField"]}>
            <DateRangePicker slots={{ field: SingleInputDateRangeField }} name="allowedRange" />
          </DemoContainer>
        </LocalizationProvider>
      </MDBox>

      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </MDBox>
    </Card>
  );
}

export default Projects;
